import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FileHolder, UploadMetadata } from 'angular2-image-upload';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';
@Component({
  selector: 'app-image-upload-input',
  templateUrl: './image-upload-input.component.html',
  styleUrls: ['./image-upload-input.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ImageUploadInputComponent),
    },
  ],
})
export class ImageUploadInputComponent implements ControlValueAccessor, OnInit {
  model = [];

  @Input() multiple = true;
  max = undefined;
  private _touched = false;
  private _onChange = (v: any) => {};
  private _onTouched = (touched: boolean) => {};
  constructor(private toaster: SnotifyService) {

  }
  ngOnInit() {
    if (this.multiple) {
      this.max = undefined;
    } else {
      this.max = 1;
    }
  }

  writeValue(newVal) {
    let val = [];

    if (newVal instanceof Array) {
      val = newVal.map((v) => ({ id: v.id || null, url: v.url }));
    } else {
      val.push({
        id: newVal.id || null,
        url: newVal.url,
      });
    }

    if (!this.multiple && val.length > 0) {
      this.max = 0;
    }
    this.model = val;
  }

  registerOnChange(onChange) {
    this._onChange = onChange;
  }

  registerOnTouched(onTouched) {
    this._onTouched = onTouched;
  }
  onBeforeUpload = (metadata: UploadMetadata) => {
    console.log(metadata);
    if (!metadata.file.type.startsWith('image')) {
      metadata.abort = true;
      const fileName = metadata.file.name;
      this.toaster.error('File: ' + fileName + ' has invalid format');
    }
    return metadata;
  }

  uploadFinished(holder: FileHolder) {
    if (holder.serverResponse.status === 200) {
      const url = holder.serverResponse.response.body.data.filePath;
      this.model.push({ url });
      this._onChange(this.model);
    }
  }

  imageRemoved(holder: FileHolder) {
    let url;
    if (holder.serverResponse) {
      // newly added file
      url = holder.serverResponse.response.body.data.filePath;
    } else {
      // already existent file
      url = holder.src;
    }
    const index = this.model.findIndex((i) => i.url === url);
    this.model.splice(index, 1);
    const currentLength = this.model.length;
    if (!this.multiple && currentLength === 0) {
      this.max = 5;
    }
    this._onChange(this.model);
  }
}
